export class ApiService{
  constructor() {
    // this.domain = `http://localhost:8081/api/v1`;
    this.domain = '/api/v1';
    
    this.token = "";
    if (localStorage.token){
      this.token = localStorage.token;
    }
    this.header =  {
      headers: { Authorization: `Bearer ${this.token}` },
      withCredentials: true
    };
  }

  login(item){
    return new Promise((resolve, reject) => {
      axios
        .post(`${this.domain}/login`,item)
        .then(response => {
          localStorage.token = response.data.token;
          localStorage.userId = response.data.id;
          localStorage.isAdmin = response.data.is_admin;
          resolve(response.data);
        })
        .catch(error => {
          reject(error.response);
        })
    });
  }

  passwordResetRequest(item) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${this.domain}/password_reset_request`, item)
          .then(response => resolve(response.data))
          .catch(error => reject(error.response))
    });
  }

  resetPassword(item, token) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${this.domain}/password_reset/${token}`, item)
          .then(response => resolve(response.data))
          .catch(error => reject(error.response))
    });
  }

  authentication(token) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${this.domain}/authentication/${token}`)
          .then(response => resolve(response.data))
          .catch(error => reject(error.response))
    });
  }

  postUser(item) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${this.domain}/users`, item)
          .then(response => resolve(response.data))
          .catch(error => reject(error.response))
    });
  }

  getUsers() {
    return new Promise((resolve, reject) => {
      axios
        .get(`${this.domain}/users`, this.header)
          .then(response => resolve(response.data))
          .catch(error => reject(error.response))
    })
  }

  getUser(userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${this.domain}/users/${userId}`, this.header)
          .then(response => resolve(response.data))
          .catch(error => reject(error.response))
    });
  }

  putUser(item) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${this.domain}/users/${item.id}`,item, this.header)
      .then(response => resolve(response.data))
        .catch(error => reject(error.response))
    });
  }
  
};
